<template>
   <div>
      <p><strong>This tour will help you set up a Page View Reward.</strong></p>
      <p>
         Only use a Page View Reward if a specific page—like a "Thank You" or
         order confirmation page—means a conversion happened.
      </p>

      <p>Each project should have only one reward:</p>
      <ul>
         <li>
            Use a <strong>Page View Reward</strong> (set up here) for page-based
            conversions.
         </li>
         <li>
            Use a <strong>Custom Reward</strong> for events like button clicks.
            <a
               href="https://docs.ezbot.ai/get-started/rewards/#custom-rewards"
               target="_blank"
               >Learn more.</a
            >
         </li>
      </ul>
   </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
   name: "WelcomeStep",
})
</script>
